// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1Z6fH","notes":"Notes_notes__30niZ","note":"Notes_note__2pyU8","markdown":"Notes_markdown__TmtMH"};